import React, { useState, useEffect } from 'react';
import { COLORS } from '../config/constants';
import { projectService } from '../services/api.service';

const Projects = ({ user }) => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingProject, setEditingProject] = useState(null);
  const [showImportModal, setShowImportModal] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [searchTerm, setSearchTerm] = useState('');
  const [importFile, setImportFile] = useState(null);

  // Proje kayıt formu (GENEL sayfasına göre)
  const [projectForm, setProjectForm] = useState({
    proje: '',
    parca_adi: '',
    parca_profil: '',
    proje_poz_no: '',
    kullanim_yeri: '',
    malzeme_turu: '',
    sac_kalinlik: '',
    bant_genisligi: '',
    bir_modulde: '',
    uzunluk: '',
    toplam_modul: '',
    miktar: '',
    birim_agirlik: '',
    agirlik: '',
    imalat_tonaj: '',
    siparis_numarasi: ''
  });

  useEffect(() => {
    loadProjects();
  }, []);

  const loadProjects = async () => {
    try {
      setLoading(true);
      const data = await projectService.getAll();
      setProjects(data);
    } catch (error) {
      console.error('Projeler yüklenirken hata:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ type: '', text: '' });

    try {
      await projectService.create({
        name: projectForm.proje,
        description: `${projectForm.parca_adi} - ${projectForm.proje_poz_no}`,
        status: 'in_progress',
        customer: projectForm.proje,
        details: {
          parca_adi: projectForm.parca_adi,
          parca_profil: projectForm.parca_profil,
          proje_poz_no: projectForm.proje_poz_no,
          kullanim_yeri: projectForm.kullanim_yeri,
          malzeme_turu: projectForm.malzeme_turu,
          sac_kalinlik: projectForm.sac_kalinlik,
          bant_genisligi: projectForm.bant_genisligi,
          bir_modulde: projectForm.bir_modulde,
          uzunluk: projectForm.uzunluk,
          toplam_modul: projectForm.toplam_modul,
          miktar: projectForm.miktar,
          birim_agirlik: projectForm.birim_agirlik,
          agirlik: projectForm.agirlik,
          imalat_tonaj: projectForm.imalat_tonaj,
          siparis_numarasi: projectForm.siparis_numarasi
        }
      });

      setMessage({ type: 'success', text: 'Proje başarıyla kaydedildi!' });
      setShowForm(false);
      loadProjects();
      
      // Formu temizle
      setProjectForm({
        proje: '',
        parca_adi: '',
        parca_profil: '',
        proje_poz_no: '',
        kullanim_yeri: '',
        malzeme_turu: '',
        sac_kalinlik: '',
        bant_genisligi: '',
        bir_modulde: '',
        uzunluk: '',
        toplam_modul: '',
        miktar: '',
        birim_agirlik: '',
        agirlik: '',
        imalat_tonaj: '',
        siparis_numarasi: ''
      });
    } catch (error) {
      setMessage({ type: 'error', text: 'Proje kaydedilirken hata oluştu.' });
    }
  };

  const handleEdit = (project) => {
    setEditingProject(project);
    setProjectForm({
      proje: project.name || '',
      parca_adi: project.details?.parca_adi || '',
      parca_profil: project.details?.parca_profil || '',
      proje_poz_no: project.details?.proje_poz_no || '',
      kullanim_yeri: project.details?.kullanim_yeri || '',
      malzeme_turu: project.details?.malzeme_turu || '',
      sac_kalinlik: project.details?.sac_kalinlik || '',
      bant_genisligi: project.details?.bant_genisligi || '',
      bir_modulde: project.details?.bir_modulde || '',
      uzunluk: project.details?.uzunluk || '',
      toplam_modul: project.details?.toplam_modul || '',
      miktar: project.details?.miktar || '',
      birim_agirlik: project.details?.birim_agirlik || '',
      agirlik: project.details?.agirlik || '',
      imalat_tonaj: project.details?.imalat_tonaj || '',
      siparis_numarasi: project.details?.siparis_numarasi || ''
    });
    setShowEditModal(true);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setMessage({ type: '', text: '' });

    try {
      await projectService.update(editingProject.id, {
        name: projectForm.proje,
        description: `${projectForm.parca_adi} - ${projectForm.proje_poz_no}`,
        status: 'in_progress',
        customer: projectForm.proje,
        details: {
          parca_adi: projectForm.parca_adi,
          parca_profil: projectForm.parca_profil,
          proje_poz_no: projectForm.proje_poz_no,
          kullanim_yeri: projectForm.kullanim_yeri,
          malzeme_turu: projectForm.malzeme_turu,
          sac_kalinlik: projectForm.sac_kalinlik,
          bant_genisligi: projectForm.bant_genisligi,
          bir_modulde: projectForm.bir_modulde,
          uzunluk: projectForm.uzunluk,
          toplam_modul: projectForm.toplam_modul,
          miktar: projectForm.miktar,
          birim_agirlik: projectForm.birim_agirlik,
          agirlik: projectForm.agirlik,
          imalat_tonaj: projectForm.imalat_tonaj,
          siparis_numarasi: projectForm.siparis_numarasi
        }
      });

      setMessage({ type: 'success', text: 'Proje başarıyla güncellendi!' });
      setShowEditModal(false);
      setEditingProject(null);
      loadProjects();
    } catch (error) {
      setMessage({ type: 'error', text: 'Proje güncellenemedi!' });
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu projeyi silmek istediğinizden emin misiniz?')) return;
    
    try {
      await projectService.delete(id);
      setMessage({ type: 'success', text: 'Proje silindi!' });
      loadProjects();
    } catch (error) {
      setMessage({ type: 'error', text: 'Proje silinemedi!' });
    }
  };

  const handleImportFile = async (e) => {
    e.preventDefault();
    if (!importFile) {
      setMessage({ type: 'error', text: 'Lütfen bir Excel dosyası seçin!' });
      return;
    }

    const formData = new FormData();
    formData.append('file', importFile);

    try {
      setLoading(true);
      const response = await projectService.importExcel(formData);
      setMessage({ type: 'success', text: `${response.imported || 0} proje başarıyla yüklendi!` });
      setShowImportModal(false);
      setImportFile(null);
      loadProjects();
    } catch (error) {
      setMessage({ type: 'error', text: 'Excel import başarısız!' });
    } finally {
      setLoading(false);
    }
  };

  const canEdit = user?.role === 'admin' || user?.role === 'operator';

  const filteredProjects = projects.filter(project =>
    project.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    project.description?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div data-testid="projects-page" style={{ padding: '2rem' }}>
      {/* Header with Actions */}
      <div style={{ marginBottom: '2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
        <div>
          <h1 style={{ fontSize: '2rem', fontWeight: '700', color: COLORS.text, margin: 0 }}>
            Proje Kayıtları
          </h1>
          <p style={{ color: COLORS.textLight, marginTop: '0.5rem' }}>
            Tüm projeler ve parçalar ({filteredProjects.length} kayıt)
          </p>
        </div>
        
        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
          {canEdit && (
            <>
              <button
                onClick={() => setShowImportModal(true)}
                style={{
                  padding: '0.75rem 1.5rem',
                  background: '#10b981',
                  color: COLORS.white,
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '0.95rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}
              >
                📊 Excel Toplu Yükle
              </button>
              <button
                onClick={() => setShowForm(!showForm)}
                style={{
                  padding: '0.75rem 1.5rem',
                  background: COLORS.primary,
                  color: COLORS.white,
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '0.95rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}
              >
                {showForm ? '❌ İptal' : '➕ Yeni Proje/Parça'}
              </button>
            </>
          )}
        </div>
      </div>

      {/* Message */}
      {message.text && (
        <div
          style={{
            padding: '1rem',
            borderRadius: '8px',
            marginBottom: '2rem',
            background: message.type === 'success' ? '#d1fae5' : '#fee2e2',
            color: message.type === 'success' ? '#065f46' : '#991b1b',
            border: `1px solid ${message.type === 'success' ? '#6ee7b7' : '#fca5a5'}`
          }}
        >
          {message.text}
        </div>
      )}

      {/* Form */}
      {showForm && canEdit && (
        <div style={{ 
          background: COLORS.white, 
          borderRadius: '12px', 
          padding: '2rem', 
          marginBottom: '2rem',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)' 
        }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', color: COLORS.text, marginBottom: '1.5rem' }}>
            Yeni Proje/Parça Kaydı
          </h2>
          
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '1.5rem' }}>
              <FormField label="Proje" value={projectForm.proje} onChange={(v) => setProjectForm({...projectForm, proje: v})} required />
              <FormField label="Parça Adı" value={projectForm.parca_adi} onChange={(v) => setProjectForm({...projectForm, parca_adi: v})} required />
              <FormField label="Parça-Profil" value={projectForm.parca_profil} onChange={(v) => setProjectForm({...projectForm, parca_profil: v})} />
              <FormField label="Proje Poz No" value={projectForm.proje_poz_no} onChange={(v) => setProjectForm({...projectForm, proje_poz_no: v})} />
              <FormField label="Kullanım Yeri" value={projectForm.kullanim_yeri} onChange={(v) => setProjectForm({...projectForm, kullanim_yeri: v})} />
              <FormField label="Malzeme Türü" value={projectForm.malzeme_turu} onChange={(v) => setProjectForm({...projectForm, malzeme_turu: v})} />
              <FormField label="Sac Kalınlık" type="number" step="0.01" value={projectForm.sac_kalinlik} onChange={(v) => setProjectForm({...projectForm, sac_kalinlik: v})} />
              <FormField label="Bant Genişliği" type="number" value={projectForm.bant_genisligi} onChange={(v) => setProjectForm({...projectForm, bant_genisligi: v})} />
              <FormField label="1 Modülde" type="number" value={projectForm.bir_modulde} onChange={(v) => setProjectForm({...projectForm, bir_modulde: v})} />
              <FormField label="Uzunluk" type="number" value={projectForm.uzunluk} onChange={(v) => setProjectForm({...projectForm, uzunluk: v})} />
              <FormField label="Toplam Modül" type="number" value={projectForm.toplam_modul} onChange={(v) => setProjectForm({...projectForm, toplam_modul: v})} />
              <FormField label="Toplam Adet" type="number" value={projectForm.miktar} onChange={(v) => setProjectForm({...projectForm, miktar: v})} required />
              <FormField label="kg/m (Birim Ağırlık)" type="number" step="0.001" value={projectForm.birim_agirlik} onChange={(v) => setProjectForm({...projectForm, birim_agirlik: v})} />
              <FormField label="Gerekli Mlz Tonajı" type="number" step="0.01" value={projectForm.imalat_tonaj} onChange={(v) => setProjectForm({...projectForm, imalat_tonaj: v})} />
              <FormField label="Toplam Ağırlık" type="number" step="0.01" value={projectForm.agirlik} onChange={(v) => setProjectForm({...projectForm, agirlik: v})} />
              <FormField label="Sipariş Numarası" value={projectForm.siparis_numarasi} onChange={(v) => setProjectForm({...projectForm, siparis_numarasi: v})} />
            </div>
            
            <div style={{ display: 'flex', gap: '1rem', marginTop: '2rem' }}>
              <button
                type="submit"
                style={{
                  padding: '1rem 2rem',
                  background: COLORS.primary,
                  color: COLORS.white,
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: 'pointer'
                }}
              >
                Kaydet
              </button>
              <button
                type="button"
                onClick={() => setShowForm(false)}
                style={{
                  padding: '1rem 2rem',
                  background: COLORS.background,
                  color: COLORS.text,
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  cursor: 'pointer'
                }}
              >
                İptal
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Search & Filter */}
      <div style={{ 
        background: COLORS.white, 
        borderRadius: '12px', 
        padding: '1.5rem',
        marginBottom: '2rem',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)' 
      }}>
        <input
          type="text"
          placeholder="🔍 Proje veya parça adı ile ara..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            width: '100%',
            padding: '0.875rem',
            border: `2px solid ${COLORS.background}`,
            borderRadius: '8px',
            fontSize: '1rem',
            outline: 'none'
          }}
          onFocus={(e) => e.target.style.borderColor = COLORS.primary}
          onBlur={(e) => e.target.style.borderColor = COLORS.background}
        />
      </div>

      {/* Projects List - Detaylı Tablo */}
      <div style={{ 
        background: COLORS.white, 
        borderRadius: '12px', 
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        overflow: 'hidden'
      }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '3rem' }}>
            <div style={{ fontSize: '2rem', color: COLORS.primary, marginBottom: '1rem' }}>⏳</div>
            <p style={{ color: COLORS.textLight }}>Yükleniyor...</p>
          </div>
        ) : filteredProjects.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '3rem' }}>
            <p style={{ color: COLORS.textLight, fontSize: '1.1rem' }}>
              {searchTerm ? 'Arama sonucu bulunamadı' : 'Henüz proje kaydı yok'}
            </p>
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.85rem' }}>
              <thead>
                <tr style={{ background: COLORS.background, borderBottom: `2px solid ${COLORS.background}` }}>
                  <th style={tableHeaderStyle}>Proje</th>
                  <th style={tableHeaderStyle}>Parça Adı</th>
                  <th style={tableHeaderStyle}>Proje Poz No</th>
                  <th style={tableHeaderStyle}>Kullanım Yeri</th>
                  <th style={tableHeaderStyle}>Malzeme Türü</th>
                  <th style={tableHeaderStyle}>Sac Kalınlık</th>
                  <th style={tableHeaderStyle}>Bant Genişliği</th>
                  <th style={tableHeaderStyle}>1 Modülde</th>
                  <th style={tableHeaderStyle}>Uzunluk</th>
                  <th style={tableHeaderStyle}>Miktar</th>
                  <th style={tableHeaderStyle}>Birim Ağırlık</th>
                  <th style={tableHeaderStyle}>Ağırlık</th>
                  {canEdit && <th style={tableHeaderStyle}>İşlemler</th>}
                </tr>
              </thead>
              <tbody>
                {filteredProjects.map((project, index) => {
                  const details = project.details || {};
                  return (
                    <tr 
                      key={project.id || index}
                      style={{ 
                        borderBottom: `1px solid ${COLORS.background}`,
                        background: index % 2 === 0 ? '#fff' : '#fafafa'
                      }}
                    >
                      <td style={{...tableCellStyle, fontWeight: '600'}}>{project.name || '-'}</td>
                      <td style={tableCellStyle}>{details.parca_adi || '-'}</td>
                      <td style={tableCellStyle}>{details.proje_poz_no || '-'}</td>
                      <td style={tableCellStyle}>{details.kullanim_yeri || '-'}</td>
                      <td style={tableCellStyle}>{details.malzeme_turu || '-'}</td>
                      <td style={{...tableCellStyle, textAlign: 'center'}}>{details.sac_kalinlik || '-'}</td>
                      <td style={{...tableCellStyle, textAlign: 'center'}}>{details.bant_genisligi || '-'}</td>
                      <td style={{...tableCellStyle, textAlign: 'center'}}>{details.bir_modulde || '-'}</td>
                      <td style={{...tableCellStyle, textAlign: 'center'}}>{details.uzunluk || '-'}</td>
                      <td style={{...tableCellStyle, textAlign: 'center', fontWeight: '600', color: COLORS.primary}}>{details.miktar || '-'}</td>
                      <td style={{...tableCellStyle, textAlign: 'center'}}>{details.birim_agirlik || '-'}</td>
                      <td style={{...tableCellStyle, textAlign: 'center', fontWeight: '700', color: COLORS.primary}}>
                        {details.agirlik ? `${parseFloat(details.agirlik).toFixed(2)} kg` : '-'}
                      </td>
                      {canEdit && (
                        <td style={{...tableCellStyle, textAlign: 'center'}}>
                          <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center' }}>
                            <button
                              onClick={() => handleEdit(project)}
                              style={{
                                padding: '0.4rem 0.8rem',
                                background: '#3b82f6',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '6px',
                                fontSize: '0.85rem',
                                cursor: 'pointer',
                                fontWeight: '500'
                              }}
                            >
                              ✏️ Düzenle
                            </button>
                            <button
                              onClick={() => handleDelete(project.id)}
                              style={{
                                padding: '0.4rem 0.8rem',
                                background: '#ef4444',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '6px',
                                fontSize: '0.85rem',
                                cursor: 'pointer',
                                fontWeight: '500'
                              }}
                            >
                              🗑️ Sil
                            </button>
                          </div>
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Summary */}
      <div style={{ 
        marginTop: '2rem',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '1rem'
      }}>
        <div style={summaryCardStyle}>
          <div style={{ fontSize: '2rem', fontWeight: '700', color: COLORS.primary }}>
            {filteredProjects.length}
          </div>
          <div style={{ color: COLORS.textLight, fontSize: '0.9rem', marginTop: '0.25rem' }}>
            Toplam Proje
          </div>
        </div>
        <div style={summaryCardStyle}>
          <div style={{ fontSize: '2rem', fontWeight: '700', color: '#10b981' }}>
            {filteredProjects.filter(p => p.status === 'in_progress').length}
          </div>
          <div style={{ color: COLORS.textLight, fontSize: '0.9rem', marginTop: '0.25rem' }}>
            Devam Eden
          </div>
        </div>
        <div style={summaryCardStyle}>
          <div style={{ fontSize: '2rem', fontWeight: '700', color: '#3b82f6' }}>
            {filteredProjects.filter(p => p.status === 'completed').length}
          </div>
          <div style={{ color: COLORS.textLight, fontSize: '0.9rem', marginTop: '0.25rem' }}>
            Tamamlanan
          </div>
        </div>
      </div>

      {/* Import Modal */}
      {showImportModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: COLORS.white,
            borderRadius: '12px',
            padding: '2rem',
            maxWidth: '600px',
            width: '90%',
            boxShadow: '0 10px 25px rgba(0,0,0,0.15)'
          }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: '600', color: COLORS.text, marginBottom: '1.5rem' }}>
              📊 Excel Toplu Yükleme
            </h2>
            
            <form onSubmit={handleImportFile}>
              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{ color: COLORS.text, fontWeight: '500', fontSize: '0.9rem', display: 'block', marginBottom: '0.5rem' }}>
                  Excel Dosyası Seçin
                </label>
                <input
                  type="file"
                  accept=".xlsx,.xls"
                  onChange={(e) => setImportFile(e.target.files[0])}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: `1px solid ${COLORS.background}`,
                    borderRadius: '8px',
                    fontSize: '1rem',
                    outline: 'none'
                  }}
                />
              </div>
              
              <div style={{ 
                background: '#f0f9ff', 
                border: '1px solid #0ea5e9', 
                borderRadius: '8px', 
                padding: '1rem', 
                marginBottom: '1rem' 
              }}>
                <p style={{ color: '#0369a1', fontSize: '0.9rem', margin: '0 0 0.75rem 0', fontWeight: '600' }}>
                  💡 Excel Formatı:
                </p>
                <ul style={{ color: '#0369a1', fontSize: '0.85rem', margin: 0, paddingLeft: '1.5rem' }}>
                  <li>GENEL sayfası olmalı (veya ilk sayfa)</li>
                  <li>İlk satır başlık satırı olmalı</li>
                  <li><strong>Zorunlu kolonlar:</strong> Proje, Parça Adı</li>
                  <li><strong>Diğer kolonlar:</strong> Parça-Profil, Proje Poz No, Malzeme Türü, Sac Kalınlık, vb.</li>
                </ul>
              </div>

              <div style={{ 
                background: '#fef3c7', 
                border: '1px solid #f59e0b', 
                borderRadius: '8px', 
                padding: '1rem', 
                marginBottom: '1.5rem' 
              }}>
                <p style={{ color: '#92400e', fontSize: '0.85rem', margin: 0 }}>
                  ⚠️ <strong>Not:</strong> Mevcut Excel dosyanızı (.xlsm) doğrudan yükleyebilirsiniz. Sistem GENEL sayfasını otomatik olarak okur.
                </p>
              </div>
              
              <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
                <button
                  type="button"
                  onClick={() => {
                    setShowImportModal(false);
                    setImportFile(null);
                  }}
                  style={{
                    padding: '0.75rem 1.5rem',
                    background: COLORS.background,
                    color: COLORS.text,
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '0.95rem',
                    cursor: 'pointer'
                  }}
                >
                  İptal
                </button>
                <button
                  type="submit"
                  disabled={!importFile || loading}
                  style={{
                    padding: '0.75rem 1.5rem',
                    background: importFile && !loading ? '#10b981' : '#9ca3af',
                    color: COLORS.white,
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '0.95rem',
                    fontWeight: '600',
                    cursor: importFile && !loading ? 'pointer' : 'not-allowed'
                  }}
                >
                  {loading ? '⏳ Yükleniyor...' : '📤 Yükle'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {showEditModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
          overflowY: 'auto',
          padding: '2rem 0'
        }}>
          <div style={{
            background: COLORS.white,
            borderRadius: '12px',
            padding: '2rem',
            maxWidth: '1200px',
            width: '95%',
            maxHeight: '90vh',
            overflowY: 'auto',
            boxShadow: '0 10px 25px rgba(0,0,0,0.15)'
          }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: '600', color: COLORS.text, marginBottom: '1.5rem' }}>
              ✏️ Proje Düzenle
            </h2>
            
            <form onSubmit={handleUpdate}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '1.5rem' }}>
                <FormField label="Proje" value={projectForm.proje} onChange={(v) => setProjectForm({...projectForm, proje: v})} required />
                <FormField label="Parça Adı" value={projectForm.parca_adi} onChange={(v) => setProjectForm({...projectForm, parca_adi: v})} required />
                <FormField label="Parça-Profil" value={projectForm.parca_profil} onChange={(v) => setProjectForm({...projectForm, parca_profil: v})} />
                <FormField label="Proje Poz No" value={projectForm.proje_poz_no} onChange={(v) => setProjectForm({...projectForm, proje_poz_no: v})} />
                <FormField label="Kullanım Yeri" value={projectForm.kullanim_yeri} onChange={(v) => setProjectForm({...projectForm, kullanim_yeri: v})} />
                <FormField label="Malzeme Türü" value={projectForm.malzeme_turu} onChange={(v) => setProjectForm({...projectForm, malzeme_turu: v})} />
                <FormField label="Sac Kalınlık" type="number" step="0.01" value={projectForm.sac_kalinlik} onChange={(v) => setProjectForm({...projectForm, sac_kalinlik: v})} />
                <FormField label="Bant Genişliği" type="number" value={projectForm.bant_genisligi} onChange={(v) => setProjectForm({...projectForm, bant_genisligi: v})} />
                <FormField label="1 Modülde" type="number" value={projectForm.bir_modulde} onChange={(v) => setProjectForm({...projectForm, bir_modulde: v})} />
                <FormField label="Uzunluk" type="number" value={projectForm.uzunluk} onChange={(v) => setProjectForm({...projectForm, uzunluk: v})} />
                <FormField label="Toplam Modül" type="number" value={projectForm.toplam_modul} onChange={(v) => setProjectForm({...projectForm, toplam_modul: v})} />
                <FormField label="Toplam Adet" type="number" value={projectForm.miktar} onChange={(v) => setProjectForm({...projectForm, miktar: v})} required />
                <FormField label="kg/m (Birim Ağırlık)" type="number" step="0.001" value={projectForm.birim_agirlik} onChange={(v) => setProjectForm({...projectForm, birim_agirlik: v})} />
                <FormField label="Gerekli Mlz Tonajı" type="number" step="0.01" value={projectForm.imalat_tonaj} onChange={(v) => setProjectForm({...projectForm, imalat_tonaj: v})} />
                <FormField label="Toplam Ağırlık" type="number" step="0.01" value={projectForm.agirlik} onChange={(v) => setProjectForm({...projectForm, agirlik: v})} />
                <FormField label="Sipariş Numarası" value={projectForm.siparis_numarasi} onChange={(v) => setProjectForm({...projectForm, siparis_numarasi: v})} />
              </div>
              
              <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end', marginTop: '2rem' }}>
                <button
                  type="button"
                  onClick={() => {
                    setShowEditModal(false);
                    setEditingProject(null);
                  }}
                  style={{
                    padding: '0.75rem 1.5rem',
                    background: COLORS.background,
                    color: COLORS.text,
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '0.95rem',
                    cursor: 'pointer'
                  }}
                >
                  İptal
                </button>
                <button
                  type="submit"
                  style={{
                    padding: '0.75rem 1.5rem',
                    background: COLORS.primary,
                    color: COLORS.white,
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '0.95rem',
                    fontWeight: '600',
                    cursor: 'pointer'
                  }}
                >
                  💾 Güncelle
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

const FormField = ({ label, value, onChange, type = 'text', step, required = false }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
      <label style={{ color: COLORS.text, fontWeight: '500', fontSize: '0.9rem' }}>
        {label} {required && <span style={{ color: COLORS.primary }}>*</span>}
      </label>
      <input
        type={type}
        step={step}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        style={{
          padding: '0.75rem',
          border: `1px solid ${COLORS.background}`,
          borderRadius: '8px',
          fontSize: '1rem',
          outline: 'none',
          transition: 'border-color 0.2s'
        }}
        onFocus={(e) => e.target.style.borderColor = COLORS.primary}
        onBlur={(e) => e.target.style.borderColor = COLORS.background}
      />
    </div>
  );
};

const getStatusColor = (status) => {
  switch (status) {
    case 'completed':
      return { bg: '#d1fae5', text: '#065f46' };
    case 'in_progress':
      return { bg: '#dbeafe', text: '#1e40af' };
    case 'on_hold':
      return { bg: '#fef3c7', text: '#92400e' };
    default:
      return { bg: '#f3f4f6', text: '#374151' };
  }
};

const getStatusText = (status) => {
  switch (status) {
    case 'completed': return 'Tamamlandı';
    case 'in_progress': return 'Devam Ediyor';
    case 'on_hold': return 'Beklemede';
    case 'planning': return 'Planlanıyor';
    default: return status;
  }
};

const tableHeaderStyle = {
  padding: '1rem',
  textAlign: 'left',
  fontSize: '0.875rem',
  fontWeight: '600',
  color: COLORS.text,
  textTransform: 'uppercase',
  letterSpacing: '0.05em'
};

const tableCellStyle = {
  padding: '1rem',
  fontSize: '0.95rem'
};

const summaryCardStyle = {
  background: COLORS.white,
  padding: '1.5rem',
  borderRadius: '12px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  textAlign: 'center'
};

export default Projects;
